class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.button = this.querySelector('.et-sticky-add-to-cart__button');
    this.productInfo = document.querySelector('product-info');
    this.addToCartButton = null;
    this.mainAddToCartButton = null;
    this.footer = null;
    this.isVisible = false;
    
    this.init();
  }

  init() {
    if (this.productInfo) {
      this.addToCartButton = this.productInfo.querySelector('button[name="add"]');
      this.mainAddToCartButton = this.addToCartButton;
    }

    this.footer = document.querySelector('footer, .footer, #shopify-section-footer');

    this.setupScrollListener();
    this.setupButtonClick();
    this.setupVariantChange();
  }

  setupScrollListener() {
    let ticking = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    this.handleScroll();
  }

  handleScroll() {
    const shouldShow = this.shouldShowStickyBar();

    if (shouldShow && !this.isVisible) {
      this.classList.add('is-visible');
      this.isVisible = true;
    } else if (!shouldShow && this.isVisible) {
      this.classList.remove('is-visible');
      this.isVisible = false;
    }
  }

  shouldShowStickyBar() {
    if (!this.mainAddToCartButton) return false;

    const mainButtonRect = this.mainAddToCartButton.getBoundingClientRect();
    const isMainButtonVisible = mainButtonRect.top < window.innerHeight && mainButtonRect.bottom > 0;

    if (isMainButtonVisible) {
      return false;
    }

    if (this.footer) {
      const footerRect = this.footer.getBoundingClientRect();
      const isFooterVisible = footerRect.top < window.innerHeight;
      
      if (isFooterVisible) {
        return false;
      }
    }

    const scrollPosition = window.scrollY;
    const mainButtonPosition = this.mainAddToCartButton.getBoundingClientRect().top + scrollPosition;
    
    return scrollPosition > mainButtonPosition;
  }

  setupButtonClick() {
    if (!this.button) return;

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      
      if (this.addToCartButton && !this.addToCartButton.disabled) {
        this.addToCartButton.click();
      }
    });
  }

  setupVariantChange() {
    if (!this.productInfo) return;

    document.addEventListener('variant:change', (event) => {
      this.updateButtonState(event.detail);
    });

    const variantSelects = this.productInfo.querySelectorAll('variant-selects, variant-radios');
    variantSelects.forEach(selector => {
      selector.addEventListener('change', () => {
        setTimeout(() => {
          this.updateButtonFromProductInfo();
        }, 100);
      });
    });
  }

  updateButtonState(variant) {
    if (!this.button) return;

    if (variant && variant.available) {
      this.button.disabled = false;
      this.button.querySelector('.et-sticky-add-to-cart__button-text').textContent = 'In winkelwagen';
    } else {
      this.button.disabled = true;
      this.button.querySelector('.et-sticky-add-to-cart__button-text').textContent = 'Uitverkocht';
    }

    this.updatePricing(variant);
  }

  updateButtonFromProductInfo() {
    if (!this.addToCartButton || !this.button) return;

    this.button.disabled = this.addToCartButton.disabled;
    
    const buttonText = this.button.querySelector('.et-sticky-add-to-cart__button-text');
    if (buttonText) {
      buttonText.textContent = this.addToCartButton.disabled ? 'Uitverkocht' : 'In winkelwagen';
    }
  }

  updatePricing(variant) {
    if (!variant) return;

    const priceElement = this.querySelector('.et-sticky-add-to-cart__price--sale') || 
                         this.querySelector('.et-sticky-add-to-cart__price');
    const compareElement = this.querySelector('.et-sticky-add-to-cart__price--compare');
    const savingsElement = this.querySelector('.et-sticky-add-to-cart__savings-badge');

    if (priceElement) {
      priceElement.textContent = this.formatMoney(variant.price);
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (compareElement) {
        compareElement.textContent = this.formatMoney(variant.compare_at_price);
      }
      if (savingsElement) {
        const savings = variant.compare_at_price - variant.price;
        savingsElement.textContent = `Bespaar ${this.formatMoney(savings)}`;
      }
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return `€${amount.toFixed(2).replace('.', ',')}`;
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
